import React, { Component } from "react";
import { useSelector } from "react-redux";
import {Button, Container, Card, Modal, Form, Row, Col} from "react-bootstrap";
// import { withRouter } from "react-router";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import Issue from "Screens1/Student/Course/Interactions/Issues/issue.jsx";
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

// Component that displays all the issues
class Issues_ extends Component {
    constructor(props) {
        super(props);
        this.state = {
            issues: [],
            load: false,
            createMode: false,
            choices: null,
            canCreateIssue: false,
            canUpdateIssue: false,
            canDeleteIssue: false,
            maxLengthOfTitle: 150,
        }
    }

    getAllIssues = async () => {
        try {
            const url = constants.base_url +
                "/issues/getIssues/" +
                this.props.context +
                "/" + this.props.context_id;
    
            const response = await httpService.get(url);
            this.setState({
                issues: response.data.issues,
                canCreateIssue: response.data.canCreate,
                canUpdateIssue: response.data.canUpdate,
                canDeleteIssue: response.data.canDelete,
                maxLengthOfTitle: response.data.maxLengthOfIssueTitle,
                load: true
            });
        } catch (error) {
            displayGlobalMessage(error.response.data.errorMsg, "error");
        }
    };
    

    getStatusList = async () => {
        try {
            const url = constants.base_url + "/issues/getStatusList";
            const response = await httpService.get(url);
            this.setState({
                choices: response.data.choices,
            });
        } catch (error) {
            displayGlobalMessage(error.response.data.errorMsg, "error");
        }
    };
    

    async componentDidMount() {
        await this.getStatusList();
        // await this.getAllIssues();
    }
    
    createIssue = async (e) => {
        e.preventDefault();
    
        let form_data = new FormData();
        form_data.append("context", this.props.context);
        form_data.append("context_id", this.props.context_id);
        form_data.append("title", e.target.Title.value);
        form_data.append("description", e.target.Description.value);
    
        const url = constants.base_url + "/issues/createIssue/";
    
        try {
            await httpService.post(url, form_data);
            await this.getAllIssues();
            displayGlobalMessage("Issue created successfully", "success");
        } catch (error) {
            displayGlobalMessage(error.response.data.errorMsg, "error");
        }
    
        this.setState({ 
            createMode: false,
        });
    };
    

    updateIssue(t_issue) {
        // when a issue is updated, the updated object has to be updated in this component
        // map is used to iterate and replace the updated object with old one
        this.setState({
            issues: this.state.issues.map(function (issue) {
                return issue.id !== t_issue.id ? issue : t_issue;
            })
        })
    }

    deleteIssue = async (id) => {
        try {
            const url = constants.base_url + "/issues/deleteIssue/" + id;
            await httpService.delete(url);
            this.setState({
                issues: this.state.issues.filter((issue) => issue.id !== id)
            });
            displayGlobalMessage("Issue deleted Successfully", "success");
        } catch (error) {
            displayGlobalMessage(error.response.data.errorMsg, "error");
        }
    };
    

    openCreateMode() {
        this.setState({ 
            createMode: true,
        });
    }

    getTitleString() {
        return "Title (max. " + this.state.maxLengthOfTitle + " characters)";
    }

    render() {
        // if (this.state.load === false || this.state.choices === null) {
        //     return (<div></div>)
        // }

        return (
            <div><Col md={10}>
                <Modal
                    show={this.state.createMode}
                    dialogClassName="modal-90w"
                    onHide={() => {
                        this.setState({
                            createMode: false
                        });
                    }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Create Issue
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={(e) => this.createIssue(e)}>
                            <Form.Group className="mb-3" controlId="Title">
                                <Form.Label>{this.getTitleString()}</Form.Label>
                                <Form.Control type="text" placeholder="" maxLength={this.state.maxLengthOfTitle}/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="Description">
                                <Form.Label>Description</Form.Label>
                                <Form.Control as="textarea" rows={3} />
                            </Form.Group>
                            <Button type="submit" variant="primary">Create</Button>
                        </Form>

                    </Modal.Body>
                </Modal>
                <Card>
                    <Card.Header>Issues</Card.Header>
                    <Card.Body>
                        {
                            this.state.canCreateIssue === true ?
                                <Row className="d-flex align-items-center">
                                    <Button
                                        variant="primary"
                                        className="create-issue"
                                        onClick={(e) => this.openCreateMode()}
                                    >
                                        {" "}
                                        Create Issue
                                    </Button>{" "}
                                </Row>
                            :
                                <div></div>
                        }

                        <Container>
                            {
                                this.state.load === false  || this.state.choices === null ?
                                    <div></div>
                                :
                                this.state.issues.map((issue, i) => (
                                    <Issue item={issue} 
                                            key={issue.id}
                                            status_names={this.state.choices}
                                            history={this.props.history}
                                            canUpdateIssue={this.state.canUpdateIssue}
                                            updateIssue={this.updateIssue.bind(this)}
                                            deleteIssue={this.deleteIssue.bind(this)}
                                            canDeleteIssue={this.state.canDeleteIssue}
                                            isIssuesScreen={true}/>
                                ))
                            }
                        </Container>
                    </Card.Body>
                </Card>
            </Col></div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        context: state.issues.context,
        context_id: state.issues.context_id
    }
}

const Issues = (props) => {
    const state = useSelector((state) => state);
    return <Issues_ context={state.issues.context} context_id={state.issues.context_id} {...props} />;
}

// export default withRouter(connect(mapStateToProps)(Issues));
export default Issues;
